export const setLocalStorage = (key, value) => {

  localStorage.setItem(key, JSON.stringify(value));

}

export const getLocalStorage = (key) => {

  return JSON.parse(localStorage.getItem(key));

}


export const sortBranches = (branches, userId) => {
  const restBranches = branches.filter(item => item.IdSucursal.toString() !== userId);
  const userBranch = branches.filter(item => item.IdSucursal.toString() === userId);

  return [...userBranch, ...restBranches];
}
